import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Package, Palette, Sparkles } from 'lucide-react';
const modules = [{
  icon: BookOpen,
  title: 'Introducción al Falso Vitral Deco',
  desc: 'Entendé qué es el falso vitral, qué piezas podés crear y cómo empezar aunque no tengas experiencia.'
}, {
  icon: Package,
  title: 'Materiales para empezar sin complicarte',
  desc: 'Conocé qué comprar, qué usar, qué evitar y cómo armar tu kit inicial sin gastar de más.'
}, {
  icon: Palette,
  title: 'Técnica paso a paso',
  desc: 'Aprendé a preparar la superficie, fijar plantillas, delinear, pintar, combinar colores, secar y terminar tus piezas.'
}, {
  icon: Sparkles,
  title: 'Terminaciones, errores comunes y soluciones',
  desc: 'Descubrí cómo corregir burbujas, manchas, pintura corrida, contornos irregulares y lograr piezas más prolijas y vendibles.'
}];
export function GuideContents() {
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-79" data-mp="12gswja8oc3a7">
      <div className="text-center mb-8 sm:mb-10" data-id="element-80" data-mp="i9fj565kxiov">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold leading-tight" data-id="element-81" data-mp="iaqkz0fgsgdc">
          Todo lo que incluye Falso Vitral Deco
        </h2>
        <p className="text-base sm:text-lg text-deco-taupe font-medium max-w-2xl mx-auto" data-id="element-82" data-mp="s6twgww7hrcy">
          Un recorrido simple y práctico para aprender desde cero, conocer los
          materiales, aplicar la técnica y lograr piezas más prolijas.
        </p>
      </div>

      <div className="space-y-4 sm:space-y-6" data-id="element-83" data-mp="166uyifo7j4u0">
        {modules.map((mod, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-deco-card rounded-2xl p-5 sm:p-6 border border-deco-warm shadow-sm flex items-start gap-4 sm:gap-6 hover:shadow-md transition-shadow" data-id="element-84" data-mp="1650b8upgr0mr" data-mpi={i}>
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-deco-bg flex items-center justify-center shrink-0 text-deco-terra border border-deco-warm" data-id="element-85" data-mp="1ov9qb56cmmvv">
              <mod.icon size={24} className="sm:w-6 sm:h-6" data-id="element-86" data-mp="3gzx6bp3096io" />
            </div>
            <div data-id="element-87" data-mp="3uqu03j8o3trb">
              <h3 className="text-lg sm:text-xl font-serif font-bold text-deco-text mb-1 sm:mb-2" data-id="element-88" data-mp="3urc26wi0h275">
                {mod.title}
              </h3>
              <p className="text-deco-text/80 text-sm sm:text-base leading-relaxed" data-id="element-89" data-mp="3pxr1uxsy3w4s">
                {mod.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      
    </section>;
}